export default __webpack_public_path__ + "static/media/sec2.cf1523e1.jpeg";